import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ScrollDirectiveSharedModule } from '@shared/core/directives/scroll/scroll.directive.shared.module';
import { MaxOnScreenHeightDirectiveSharedModule } from '@shared/core/directives/maxOnScreenHeight/max-on-screen-height.directive.shared.module';
import { TileForCartModule } from '@shared/core/components/tiles/tilesTypes/forCart';

import { CartItemsComponent } from './cart-items.shared.component';

@NgModule({
    declarations: [
        CartItemsComponent
    ],
    imports: [
        CommonModule,
        ScrollDirectiveSharedModule,
        MaxOnScreenHeightDirectiveSharedModule,
        TileForCartModule,
    ],
    exports: [
        CartItemsComponent
    ],
})
export class CartItemsModule { }
